import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a3bf8aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "allert"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info fa-beat" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "bts-info" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "dialog-wrapper" }
const _hoisted_11 = { class: "dialog-content" }
const _hoisted_12 = { class: "dialog-title" }
const _hoisted_13 = { class: "list-group list-group-flush" }
const _hoisted_14 = { class: "list-group-item normal" }
const _hoisted_15 = { class: "list-group-item normal" }
const _hoisted_16 = { style: {} }
const _hoisted_17 = {
  key: 0,
  class: "list-group-item normal"
}
const _hoisted_18 = {
  key: 0,
  class: "fa-solid fa-check"
}
const _hoisted_19 = {
  key: 1,
  class: "fa-solid fa-xmark"
}
const _hoisted_20 = {
  key: 2,
  class: "fa-solid fa-check"
}
const _hoisted_21 = {
  key: 3,
  class: "fa-solid fa-xmark"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = {
  key: 4,
  class: "fa-solid fa-check"
}
const _hoisted_25 = {
  key: 5,
  class: "fa-solid fa-xmark"
}
const _hoisted_26 = {
  key: 6,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_27 = { class: "list-group-item normal" }
const _hoisted_28 = {
  key: 0,
  class: "list-group"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "list-group-item normal" }
const _hoisted_31 = ["title"]
const _hoisted_32 = {
  key: 0,
  class: "fa-solid fa-question fa-beat",
  style: {"color":"#e93f3f"}
}
const _hoisted_33 = {
  key: 1,
  class: "fa-solid fa-question"
}
const _hoisted_34 = { class: "dialog-actions" }
const _hoisted_35 = { class: "dialog-wrapper" }
const _hoisted_36 = { class: "dialog-content" }
const _hoisted_37 = { class: "dialog-title" }
const _hoisted_38 = { class: "list-group list-group-flush" }
const _hoisted_39 = { class: "list-group-item normal" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "fa-solid fa-check"
}
const _hoisted_42 = {
  key: 1,
  class: "fa-regular"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = {
  key: 2,
  class: "fa-solid fa-check"
}
const _hoisted_45 = {
  key: 3,
  class: "fa-regular"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = {
  key: 4,
  class: "fa-solid fa-check"
}
const _hoisted_48 = {
  key: 5,
  class: "fa-regular"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = {
  key: 6,
  class: "fa-solid fa-check"
}
const _hoisted_51 = {
  key: 7,
  class: "fa-regular"
}
const _hoisted_52 = { class: "list-group-item normal" }
const _hoisted_53 = ["v-if"]
const _hoisted_54 = {
  key: 0,
  class: "list-group-item normal"
}
const _hoisted_55 = {
  key: 1,
  class: "list-group-item normal"
}
const _hoisted_56 = {
  key: 2,
  class: "list-group-item normal"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-map-location-dot" }, null, -1))
const _hoisted_58 = { class: "dialog-actions" }
const _hoisted_59 = { class: "dialog-wrapper" }
const _hoisted_60 = { class: "dialog-content" }
const _hoisted_61 = { class: "dialog-title" }
const _hoisted_62 = { class: "list-group list-group-flush" }
const _hoisted_63 = { class: "list-group-item normal" }
const _hoisted_64 = { class: "list-group-item normal" }
const _hoisted_65 = { class: "dialog-actions" }
const _hoisted_66 = { class: "dialog-wrapper" }
const _hoisted_67 = { class: "dialog-content" }
const _hoisted_68 = { class: "dialog-title" }
const _hoisted_69 = { class: "list-group list-group-flush" }
const _hoisted_70 = { class: "list-group-item normal" }
const _hoisted_71 = { class: "list-group-item normal" }
const _hoisted_72 = { class: "list-group-item normal" }
const _hoisted_73 = { class: "dialog-actions" }
const _hoisted_74 = { class: "dialog-wrapper" }
const _hoisted_75 = { class: "dialog-content" }
const _hoisted_76 = { class: "dialog-title" }
const _hoisted_77 = { class: "list-group list-group-flush" }
const _hoisted_78 = { class: "list-group-item normal" }
const _hoisted_79 = { class: "list-group-item normal" }
const _hoisted_80 = { class: "dialog-actions" }
const _hoisted_81 = { class: "dialog-wrapper" }
const _hoisted_82 = { class: "dialog-content" }
const _hoisted_83 = { class: "dialog-title" }
const _hoisted_84 = { class: "list-group list-group-flush" }
const _hoisted_85 = { class: "list-group-item normal" }
const _hoisted_86 = { class: "list-group-item normal" }
const _hoisted_87 = { class: "dialog-actions" }
const _hoisted_88 = { class: "dialog-wrapper" }
const _hoisted_89 = { class: "dialog-content" }
const _hoisted_90 = { class: "dialog-title" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_93 = { class: "list-group" }
const _hoisted_94 = { class: "list-group-item" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cloud-arrow-down" }, null, -1))
const _hoisted_96 = { class: "list-group-item" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-arrow-down" }, null, -1))
const _hoisted_98 = { class: "list-group-item" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1))
const _hoisted_100 = { class: "list-group" }
const _hoisted_101 = { class: "list-group-item" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check" }, null, -1))
const _hoisted_103 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BTSinfo = _resolveComponent("BTSinfo")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_Satellites = _resolveComponent("Satellites")!
  const _component_SDCard = _resolveComponent("SDCard")!
  const _component_Battery = _resolveComponent("Battery")!
  const _component_DeviceTime = _resolveComponent("DeviceTime")!
  const _component_SimCard = _resolveComponent("SimCard")!
  const _component_Progressbar = _resolveComponent("Progressbar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GDialog = _resolveComponent("GDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["wrap-container", _ctx.isScanning()])
    }, [
      (_ctx.btsTracker.isScanning == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("advice.status")), 1))
        : _createCommentVNode("", true),
      (_ctx.btsTracker.licenseActive == 0)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$t("license.noLicense")), 1))
        : (_ctx.btsTracker.licenseActive == -1)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t("license.loadingLicense")), 1))
          : _createCommentVNode("", true),
      (_ctx.btsTracker.licenseActive != 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "btn btn-warning",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogNews = true))
          }, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.btsTracker.percLoadingLicense.length > 0 && _ctx.btsTracker.licenseActive != 1)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(_ctx.$t("searchCell.Loading")) + ": " + _toDisplayString(_ctx.btsTracker.percLoadingLicense) + "%", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_InfoBox, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogStateInfo = true)),
          startColor: _ctx.getInfoColor(),
          stopColor: _ctx.getInfoColor(),
          completedSteps: _ctx.getInfo(),
          totalSteps: 1
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_BTSinfo, { status: _ctx.Btsinfo }, null, 8, ["status"])
          ]),
          text: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view.status.bts_info")), 1)
          ]),
          _: 1
        }, 8, ["startColor", "stopColor", "completedSteps"]),
        (_ctx.btsTracker.licenseActive == 1)
          ? (_openBlock(), _createBlock(_component_InfoBox, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogStateGPS = true)),
              startColor: "#10ac84",
              stopColor: "#10ac84",
              completedSteps: _ctx.getGPSPercentage(),
              totalSteps: 2
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_Satellites, {
                  status: _ctx.getGPSPercentage()
                }, null, 8, ["status"])
              ]),
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.gpsState ? _ctx.$t("view.status.coordinates", {
              "lat": _ctx.btsTracker.latitude.toFixed(3), "long":
                _ctx.btsTracker.longitude.toFixed(3)
            }) : _ctx.$t("view.status.coordinatesNotFound")), 1)
              ]),
              _: 1
            }, 8, ["completedSteps"]))
          : _createCommentVNode("", true),
        (_ctx.btsTracker.licenseActive == 1)
          ? (_openBlock(), _createBlock(_component_InfoBox, {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogStateSD = true)),
              startColor: _ctx.getSdCardColor(),
              stopColor: _ctx.getSdCardColor(),
              completedSteps: _ctx.btsTracker.sdCardUsedSize,
              totalSteps: _ctx.btsTracker.sdCardTotalSize
            }, _createSlots({
              icon: _withCtx(() => [
                _createVNode(_component_SDCard, {
                  status: _ctx.getSDstatus()
                }, null, 8, ["status"])
              ]),
              _: 2
            }, [
              (_ctx.btsTracker.caricamentoSD == false)
                ? {
                    name: "text",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getSDstatus() ? _ctx.$t("view.status.used_space", { "used_space": _ctx.getSDCardPercentage().toFixed(3) }) :
            _ctx.$t("view.status.sd_not_found")), 1)
                    ]),
                    key: "0"
                  }
                : {
                    name: "text",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view.status.carica")) + "... ", 1)
                    ]),
                    key: "1"
                  }
            ]), 1032, ["startColor", "stopColor", "completedSteps", "totalSteps"]))
          : _createCommentVNode("", true),
        (_ctx.btsTracker.licenseActive == 1)
          ? (_openBlock(), _createBlock(_component_InfoBox, {
              key: 2,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogStateBattery = true)),
              startColor: _ctx.getBatteryColor(),
              stopColor: _ctx.getBatteryColor(),
              completedSteps: _ctx.btsTracker.mediaBatteria,
              totalSteps: 100
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_Battery, {
                  status: _ctx.btsTracker.mediaBatteria
                }, null, 8, ["status"])
              ]),
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("view.status.battery", { "percentage": _ctx.btsTracker.mediaBatteria })) + "% ", 1)
              ]),
              _: 1
            }, 8, ["startColor", "stopColor", "completedSteps"]))
          : _createCommentVNode("", true),
        _createVNode(_component_InfoBox, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogStateTime = true)),
          startColor: "#10ac84",
          stopColor: "#10ac84",
          completedSteps: _ctx.getTime(),
          totalSteps: 12
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_DeviceTime, {
              deviceDate: _ctx.deviceDateInfo()
            }, null, 8, ["deviceDate"])
          ]),
          text: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btsTracker.deviceDataTime), 1)
          ]),
          _: 1
        }, 8, ["completedSteps"]),
        (_ctx.btsTracker.init && _ctx.btsTracker.licenseActive == 1)
          ? (_openBlock(), _createBlock(_component_InfoBox, {
              key: 3,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogStateSIM = true)),
              startColor: "#10ac84",
              stopColor: "#10ac84",
              completedSteps: _ctx.btsTracker.numSim,
              totalSteps: 3
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SimCard, {
                  status: _ctx.btsTracker.numSim
                }, null, 8, ["status"])
              ]),
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.btsTracker.numSim ? _ctx.$t("view.status.sim_found", { "num": _ctx.btsTracker.numSim }) :
              _ctx.$t("view.status.sim_not_found")), 1)
              ]),
              _: 1
            }, 8, ["completedSteps"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.btsTracker.perc < 100)
          ? (_openBlock(), _createBlock(_component_Progressbar, {
              key: 0,
              current: _ctx.btsTracker.perc,
              max: 100
            }, null, 8, ["current"]))
          : _createCommentVNode("", true),
        (_ctx.btsTracker.licenseActive == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.btsTracker.init && (_ctx.btsTracker.moduleWifi == 0 ||
        _ctx.btsTracker.moduleWifi
        == 1) ? _ctx.$t("view.status.initComplete") :
        _ctx.$t("view.status.initRunning")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disconnect()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("disconnect")), 1)
          ]),
          _: 1
        })
      ])
    ], 2),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateInfo,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogStateInfo) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("view.status.bts_info")), 1),
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createTextVNode("S/N: "),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.btsTracker.serial) = $event)),
                  rows: "1",
                  readonly: "",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.btsTracker.serial]
                ])
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t("view.status.firm_version")) + ": ", 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.btsTracker.version), 1)
              ]),
              (_ctx.btsTracker.licenseActive == 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _createTextVNode(" MOD A: "),
                    (_ctx.btsTracker.modA == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                      : (_openBlock(), _createElementBlock("i", _hoisted_19)),
                    _createTextVNode(" MOD B: "),
                    (_ctx.btsTracker.modB == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                      : (_openBlock(), _createElementBlock("i", _hoisted_21)),
                    _createVNode(_component_router_link, {
                      class: "btn btn-outline-primary",
                      to: "/band",
                      role: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogStateInfo = false)),
                      style: {"position":"absolute","right":"0%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }),
                    _hoisted_23,
                    _createTextVNode(" MOD wifi+bluetooth: "),
                    (_ctx.btsTracker.moduleWifi == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                      : (_ctx.btsTracker.moduleWifi == 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                        : (_openBlock(), _createElementBlock("i", _hoisted_26))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.$t("license.infoLicense")) + " ", 1),
                (_ctx.btsTracker.infoLicense.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.btsTracker.infoLicense.length - 1, (x) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-group-item",
                          key: x
                        }, _toDisplayString(this.btsTracker.infoLicense[x]), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_29, _toDisplayString(_ctx.$t("license.noLicense")), 1))
              ]),
              _createElementVNode("li", _hoisted_30, [
                _createTextVNode(_toDisplayString(_ctx.$t("view.status.manual")) + " ", 1),
                _createElementVNode("a", {
                  type: "button",
                  class: "btn btn-outline-primary",
                  href: "https://securcube.net/bts-tracker-5g-user-manual/",
                  target: "_blank",
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  title: _ctx.$t('news'),
                  style: {"position":"absolute","right":"0%"}
                }, [
                  (_ctx.btsTracker.version.indexOf(_ctx.btsTracker.lastVersionF) < 0)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                    : (_openBlock(), _createElementBlock("i", _hoisted_33))
                ], 8, _hoisted_31)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_Button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogStateInfo = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateGPS,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialogStateGPS) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("view.status.coord_data")), 1),
            _createElementVNode("ul", _hoisted_38, [
              _createElementVNode("li", _hoisted_39, [
                _createTextVNode(_toDisplayString(_ctx.$t("view.status.origine")) + " ", 1),
                _hoisted_40,
                (_ctx.device)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                  : (_openBlock(), _createElementBlock("i", _hoisted_42)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("view.status.devLoc")) + " ", 1),
                _hoisted_43,
                (_ctx.btsTracker.manuallyPosition)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                  : (_openBlock(), _createElementBlock("i", _hoisted_45)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("view.status.manuallyLoc")) + " ", 1),
                _hoisted_46,
                (_ctx.btsTracker.gpsBTS4G)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_47))
                  : (_openBlock(), _createElementBlock("i", _hoisted_48)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("view.status.modLoc")) + "(MOD A) ", 1),
                _hoisted_49,
                (_ctx.btsTracker.gpsBTS5G)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_50))
                  : (_openBlock(), _createElementBlock("i", _hoisted_51)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("view.status.modLoc")) + "(MOD B) ", 1)
              ]),
              _createElementVNode("li", _hoisted_52, _toDisplayString(_ctx.gpsState ? _ctx.$t("view.status.lat", {
            "lat": _ctx.btsTracker.latitude.toFixed(5)
          }) :
            _ctx.$t("view.status.coordinatesNotFound")), 1),
              _createElementVNode("li", {
                class: "list-group-item normal",
                "v-if": _ctx.gpsState == 1
              }, _toDisplayString(_ctx.gpsState ? _ctx.$t("view.status.long", {
              "long":
                _ctx.btsTracker.longitude.toFixed(5)
            }) : _ctx.$t("space")), 9, _hoisted_53),
              (_ctx.BTS == 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_54, _toDisplayString(_ctx.gpsState && _ctx.BTS == 1 ? _ctx.$t("view.status.alt", { "alt": _ctx.btsTracker.altitude.toFixed(2) }) : _ctx.$t("space")), 1))
                : _createCommentVNode("", true),
              (_ctx.BTS == 0 && _ctx.btsTracker.manuallyPosition == false)
                ? (_openBlock(), _createElementBlock("li", _hoisted_55, _toDisplayString(_ctx.gpsState && _ctx.BTS == 0 ? _ctx.$t("view.status.acc", { "acc": _ctx.btsTracker.accuracy.toFixed(3) }) : _ctx.$t("space")), 1))
                : _createCommentVNode("", true),
              (_ctx.btsTracker.tipo == -1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                    _createTextVNode(_toDisplayString(_ctx.$t("view.status.infoSetManualLocation")) + " ", 1),
                    _hoisted_57
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_Button, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.myFunction()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("view.status.copiaInfo")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "spacing copy",
              to: "/map"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.dialogStateGPS = false;})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("view.status.mappa")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              onClick: _cache[14] || (_cache[14] = ($event: any) => ( _ctx.dialogStateGPS = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateSD,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dialogStateSD) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t("view.status.sdCardDati")), 1),
            _createElementVNode("ul", _hoisted_62, [
              _createElementVNode("li", _hoisted_63, _toDisplayString(_ctx.$t("view.status.spazioUsato")) + ": " + _toDisplayString(_ctx.getPrettySize(_ctx.btsTracker.sdCardUsedSize)), 1),
              _createElementVNode("li", _hoisted_64, _toDisplayString(_ctx.$t("view.status.spazioTotale")) + ": " + _toDisplayString(_ctx.getPrettySize(_ctx.btsTracker.sdCardTotalSize)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_Button, {
              disabled: _ctx.btsTracker.isScanning,
              onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.btsTracker.updateSD = true; _ctx.updateSDCard(); _ctx.dialogStateSD = false})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("update")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Button, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => ( _ctx.dialogStateSD = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateSIM,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialogStateSIM) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("view.status.simDati")), 1),
            _createElementVNode("ul", _hoisted_69, [
              _createElementVNode("li", _hoisted_70, "SIM A1: " + _toDisplayString(_ctx.btsTracker.simH), 1),
              _createElementVNode("li", _hoisted_71, "SIM B1: " + _toDisplayString(_ctx.btsTracker.simS1) + " " + _toDisplayString(_ctx.btsTracker.pin1), 1),
              _createElementVNode("li", _hoisted_72, "SIM B2: " + _toDisplayString(_ctx.btsTracker.simS2) + " " + _toDisplayString(_ctx.btsTracker.pin2), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_component_Button, {
              onClick: _cache[19] || (_cache[19] = ($event: any) => ( _ctx.dialogStateSIM = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateBattery,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.dialogStateBattery) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("view.status.battDati")), 1),
            _createElementVNode("ul", _hoisted_77, [
              _createElementVNode("li", _hoisted_78, _toDisplayString(_ctx.$t("view.status.perc")) + ": " + _toDisplayString(_ctx.btsTracker.mediaBatteria) + "%", 1),
              _createElementVNode("li", _hoisted_79, _toDisplayString(_ctx.btsTracker.usbConnected ? _ctx.$t("ctrue") : _ctx.$t("space")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_Button, {
              onClick: _cache[21] || (_cache[21] = ($event: any) => ( _ctx.dialogStateBattery = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogStateTime,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogStateTime) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("view.status.clock")), 1),
            _createElementVNode("ul", _hoisted_84, [
              _createElementVNode("li", _hoisted_85, _toDisplayString(_ctx.$t("view.status.devTime")) + ": " + _toDisplayString(_ctx.btsTracker.deviceDataTime), 1),
              _createElementVNode("li", _hoisted_86, _toDisplayString(_ctx.$t("view.status.utcTime")) + ": " + _toDisplayString(_ctx.btsTracker.deviceData) + " " + _toDisplayString(_ctx.btsTracker.deviceTime), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_Button, {
              onClick: _cache[23] || (_cache[23] = ($event: any) => ( _ctx.dialogStateTime = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GDialog, {
      style: {},
      "border-radius": '15px',
      modelValue: _ctx.dialogNews,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dialogNews) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("license.newsTitle")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText1")), 1),
            _hoisted_91,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText2")), 1),
            _hoisted_92,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText3")) + " ", 1),
            _createElementVNode("ul", _hoisted_93, [
              _createElementVNode("li", _hoisted_94, [
                _hoisted_95,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText4")), 1)
              ]),
              _createElementVNode("li", _hoisted_96, [
                _hoisted_97,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText5")), 1)
              ]),
              _createElementVNode("li", _hoisted_98, [
                _hoisted_99,
                _createTextVNode(_toDisplayString(_ctx.$t("license.newsText6")), 1)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("license.newsText7")) + " ", 1),
            _createElementVNode("ul", _hoisted_100, [
              _createElementVNode("li", _hoisted_101, [
                _hoisted_102,
                _createTextVNode(_toDisplayString(_ctx.$t("license.newsText8")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createVNode(_component_Button, {
              onClick: _cache[25] || (_cache[25] = ($event: any) => ( _ctx.dialogNews = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}